(function () {
    let jQueryBopis, $location, body, homeStore, stores, userHomeStore, otherStores, latlon, userLocationPoint, spinner;

    // map of storeCode -> store object for the most recently rendered store cards, read by the
    // delegated click handlers set up once in init() instead of binding a listener per card
    let renderedStoresByCode = {};

    // const locationJSON = {
    //   101: "68617175100",
    //   102: "70139936828",
    //   103: "70140035132",
    //   104: "70140133436",
    //   105: "70140166204",
    //   106: "70140198972",
    //   107: "70140231740",
    //   108: "70140264508",
    //   109: "70140297276",
    //   110: "70140330044",
    //   111: "70140362812",
    //   112: "70140395580",
    //   113: "70140428348",
    //   114: "70140493884",
    //   115: "70140526652",
    //   116: "70140592188",
    //   117: "70140756028",
    //   118: "70140788796",
    //   119: "70140821564",
    //   120: "70140854332",
    //   121: "70140887100",
    //   122: "70140919868",
    //   123: "70140952636",
    //   124: "70141018172",
    //   125: "70141050940",
    //   126: "70141083708",
    //   127: "70141116476",
    //   128: "70141214780",
    //   129: "70141280316",
    //   130: "70141313084",
    //   131: "70141378620",
    //   132: "70141411388",
    //   133: "70141444156",
    //   134: "70141476924",
    //   135: "70141575228",
    //   136: "70141607996",
    //   137: "70141640764",
    //   138: "70141706300",
    //   139: "70141771836",
    //   140: "70141804604",
    //   141: "70141837372",
    //   142: "70141870140",
    //   143: "70141902908",
    //   144: "70141935676",
    //   145: "70142066748",
    //   146: "70142132284",
    //   147: "70142165052",
    //   148: "70142230588",
    //   149: "70142263356",
    //   150: "70142296124",
    //   151: "70142361660",
    //   152: "70142394428",
    //   153: "70142427196",
    //   154: "70142459964",
    //   155: "70142492732",
    //   156: "70142525500",
    //   157: "70142558268",
    //   158: "70142591036",
    //   159: "70142623804",
    //   160: "70142656572",
    //   161: "70142689340",
    //   162: "70142722108",
    //   163: "70142754876",
    //   164: "70142787644",
    //   165: "70142918716",
    //   166: "70142951484",
    //   167: "70143049788",
    //   168: "72734998588",
    //   169: "70143115324",
    //   170: "70143148092",
    //   171: "70143180860",
    //   172: "70143213628",
    //   173: "70143246396",
    //   174: "72751743036",
    //   175: "72751775804"
    // }

    // Production
    const locationJSON = {
        "102": "71119601708",
        "103": "71119634476",
        "104": "71119863852",
        "105": "71119896620",
        "106": "71119929388",
        "107": "71119962156",
        "108": "71119994924",
        "109": "71120027692",
        "110": "71120060460",
        "111": "71120093228",
        "112": "71120125996",
        "113": "71120158764",
        "114": "71120224300",
        "115": "71120289836",
        "116": "71120322604",
        "117": "71120420908",
        "118": "71120453676",
        "119": "71120486444",
        "120": "71120551980",
        "121": "71120584748",
        "122": "71120617516",
        "123": "71120650284",
        "124": "71120814124",
        "125": "71120846892",
        "126": "71120879660",
        "127": "71120912428",
        "128": "71120977964",
        "129": "71121010732",
        "130": "71121076268",
        "131": "71121141804",
        "132": "71121174572",
        "133": "71121207340",
        "134": "71121240108",
        "135": "71121371180",
        "136": "71121436716",
        "137": "71121469484",
        "138": "71121502252",
        "139": "71121535020",
        "140": "71121567788",
        "141": "71121600556",
        "142": "71121633324",
        "143": "71121666092",
        "144": "71121698860",
        "145": "71121829932",
        "146": "71121862700",
        "147": "71121895468",
        "148": "71121928236",
        "149": "71121961004",
        "150": "71121993772",
        "151": "71122059308",
        "152": "71122092076",
        "153": "71122124844",
        "154": "71122157612",
        "155": "71122190380",
        "156": "71122223148",
        "157": "71122255916",
        "158": "71122288684",
        "159": "71122321452",
        "160": "71122354220",
        "161": "71122386988",
        "162": "71122419756",
        "163": "71122485292",
        "164": "71122550828",
        "165": "71122714668",
        "166": "71122747436",
        "167": "71122780204",
        "168": "71122845740",
        "169": "71122878508",
        "170": "71122911276",
        "171": "71122944044",
        "172": "71123206188",
        "173": "71123238956",
        "174": "73766862892",
        "175": "73766928428",
        "STR-506-THIRD-AVENUE": "77301678124",
        "STORE-507": "80905961516"
    }
    
    // defining a global object having properties which let merchant configure some behavior
    this.bopisCustomConfig = {
        'enableCartRedirection': true,
        'searchProximity': 50, // the radius (in miles) in which the stores needs to be searched
        'searchInputPlaceholder': 'Search by zip code (50 mile radius)'
    };
      
    let baseUrl = 'https://ashley-stewart-oms.hotwax.io';
    let maargUrl = "https://ashley-stewart-maarg.hotwax.io"
  
    let loadScript = function(url, callback){
  
        let script = document.createElement("script");
        script.type = "text/javascript";
  
        if (script.readyState){ 
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function(){
                callback();
            };
        }
    
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
        
    };

    /*
    Add external stylesheets in the DOM

    @param {string} url Link to be added in the DOM
    */
    function addExternalLink(url) {
        let style = document.createElement("link");
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = url;
        document.getElementsByTagName("head")[0].appendChild(style);
    }

    addExternalLink(`${baseUrl}/api/script?shopId=10000&scriptTypeId=BOPIS_CSS_SCRPT_TAG`)
    addExternalLink('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.2/css/all.min.css')

    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn['jquery']) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js', async function(){
            jQueryBopis = jQuery.noConflict(true);
            jQueryBopis(document).ready(async function() {
                await init();
            });
  
        });
    } else {
        jQueryBopis = jQuery;
        jQuery(document).ready(async function() {
            await init();
        });
    }
  
    /*
    Fetch the current location of the user using browser's navigator object
  
    @return {location}
    */
    function getCurrentLocation () {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        })
    }

    function toggleBackdrop() {
      jQueryBopis(".background-overlay")[0].classList.toggle("hc-theme-backdrop");
    }
  
    // function will open the modal for the bopis
    async function openBopisModal (event) {
        // to stop event bubbling when clicking on the Check Stores button
        event.preventDefault();
        event.stopImmediatePropagation();

        toggleBackdrop();
        // add overflow style to disable background scroll when modal is opened
        jQueryBopis("body").css("overflow", "hidden");
        jQueryBopis(".hc-bopis-modal")[0].style.display = "block";

        // inventory is only needed once the shopper opens the modal, so it is checked here instead of on page load
        jQueryBopis('.hc-store-information').empty();
        addLoader('.hc-store-information');

        await handleAddToCartEvent();
    }
  
    function closeBopisModal () {
        jQueryBopis(".hc-bopis-modal")[0].style.display = "none";
        jQueryBopis("body").css("overflow", "scroll");
        toggleBackdrop();
    }

    /*
    Gets the user home store code from the localStorage

    @return {string} user's home store code and empty string if not found
    */
    function getUserStorePreference() {
        const storeCode = localStorage.getItem('HC_CURRENT_STORE')
        return storeCode && storeCode !== 'null' ? storeCode : '';
    }
  
    /*
        Adds a loader/spinner to the elementId passed. Cloning the spinner object before appending as to not share the same reference when adding on multiple places
  
        @param {string} elementId Element to which the spinner/loader needs to be added
    */
    function addLoader(elementId) {
        jQueryBopis(elementId).append(spinner.clone());
    }
  
    /*
        This method adds the spinner in the header section. Defined a separate method due to styling issues.
        Adds a loader/spinner to the home store element.
    */
    function addHomeStoreLoader() {
        jQueryBopis('#hc-home-store #store').append('<i class="fa fa-spinner hc-loading"></i>');
    }
  
    /*
        Removes a loader/spinner from the elementId passed. It search for `hc-loader-parent` class inside the elementId passed
  
        @param {string} elementId Element from which the spinner/loader needs to be removed
    */
    function removeLoader(elementId) {
        jQueryBopis(`${elementId} > .hc-loader-parent`).remove();
    }
  
    /*
      Add clear icon on the input field when the input field has some value in it
  
      @param {identifier} form identifier inside which we need to search for input field
    */
    function toggleClearIcon(identifier, event) {
        event.preventDefault();
        if(jQueryBopis(`${identifier} input`).val().length) {
            jQueryBopis(`${identifier} .hc-close-icon`).show();
        } else {
            jQueryBopis(`${identifier} .hc-close-icon`).hide();
        }
    }
  
    /*
      Clears the search field text and makes the default search
  
      @param {string} identifier
    */
    function clearSearch(identifier, event) {
        event.preventDefault();
  
        jQueryBopis(`${identifier} input`).val('').trigger('input');    // triggering input event, as when using val() function to update the value of input, input event does not trigger automatically
        jQueryBopis(`${identifier} button`).click();
    }
  
    /*
      Function fetches the current location(lat, lon) of the user by calling getCurrentLocation function and if found, then fetches the
      zipCode for the latLon, and sets the zipCode in the input search field using `val` method and then call the click event for the button
      element of the identifier
  
      @param {string} identifier Form element identifier inside which `Use My Location` feature is used
      @param {event} event Event for which the function is called
      */
      async function fetchStoresUsingCurrentLocation(identifier, event) {
        event.preventDefault();
  
        jQueryBopis(`${identifier} input`).val('');
  
        try {
            const userLocation = await getCurrentLocation()
            $location = userLocation.coords;
        } catch(err) {
            console.error(err.message)
        }
  
        userLocationPoint = $location ? `${$location.latitude}, ${$location.longitude}` : ''
        let zipCode = ''
  
        // user's latLon are available then only fetching the zipCode for the latLon
        if(userLocationPoint) {
            zipCode = await getZipCodeForLatlon(userLocationPoint);
        }
  
        latlon = userLocationPoint;
        jQueryBopis(`${identifier} i`).removeClass('fa-location-dot').addClass('fa-location-pin-lock');
        jQueryBopis(`${identifier} input`).val(zipCode);
        jQueryBopis(`${identifier} button`).click();
  
        // checking for zipCode as in some cases we might not have zipCode available for a latLon and in that we don't need to display the clear icon
        // triggering input event, as when using val() function to update the value of input, input event does not trigger automatically
        if(zipCode) {
            jQueryBopis(`${identifier} input`).trigger('input');
        }
    }
  
    // uses the variant data rendered on the page, so no network call is needed to decide whether to show the button
    function isProductAvailable() {
        const variantId = jQueryBopis(".hc-product-form .selected-variant-id").val()
        const variant = variantId && typeof hc_product_information !== 'undefined' ? hc_product_information[variantId] : null

        if(!variant) return false

        return variant.inventory > 0 || variant.inventory_policy === 'continue'
    }
  
    /*
      Function performs the initial operation for bopis app, like fetching homeStore ele, getting shopifyShopId, defining spinner/loader and,
      calling methods to display stores information in header and PDP
      */
    async function init() {
        body = jQueryBopis("body")
        homeStore = jQueryBopis('#hc-home-store');
        spinner = jQueryBopis('<div class="hc-loader-parent"><i class="fa fa-spinner hc-loading"></i></div>')

        // single delegated listener for every "SET AS MY STORE" button rendered inside a store card,
        // instead of binding a new listener on every card each time the dropdown is rendered
        body.on('click', '.hc-home-store-dropdown-button', function(event) {
            const store = renderedStoresByCode[jQueryBopis(this).data('storeCode')];
            if (store) updateUserStorePreference(store, event);
        });

        // single delegated listener for every "Pick Up Here" button rendered inside a store card,
        // instead of binding a new listener on every card each time stores are rendered
        body.on('click', '.hc-store-pick-up-button', function(event) {
            const store = renderedStoresByCode[jQueryBopis(this).data('storeCode')];
            if (store) updateCart(store, event);
        });

        await updateStoresInformation();

        body.on('click', function(event) {
            if (event.target == jQueryBopis("#hc-dropdown-backdrop")[0]) {
                closeStoreDropdown();
            }
        })
    }
  
    /*
      Function prepares the distance to be displayed on the UI.
      Used parseFloat as toFixed returns a string and thus toLocaleString method does not work
  
      @param {object} store Object containing store information
      @return {string} distance with one decimal value and postfix with `mi`
      */
    function getStoreDistance(store) {
        // used parseFloat as toFixed returns a string and thus toLocaleString method does not work
        return store.dist && store.dist != 'Infinity' ? parseFloat((store.dist).toFixed(1)).toLocaleString() + ' mi' : ''
    }
  
    /*
      Generates the store information card to be displayed on the dropdown page
  
      @param {object} store Contains store information
      @return {ele} HTML DOM element that will be appended in dropdown
      */
    function generateStoreInformationDropdownCard(store) {
        const storeTodayTiming = getStoreTodayTiming(store.timings);
  
        let $storeInformationCard = jQueryBopis(`
        <div class="hc-store-title"><h4 class="hc-font-m">${store.storeName}</h4>
            <span>${getStoreDistance(store)}</span>
        </div>
        <div class="hc-store-dropdown-details">
            <div class="hc-store-dropdown-details-column">
              <p class="hc-text">${store.address1 ? store.address1 : ''}</p>
              <p class="hc-text">${store.city ? store.city : ''}${store.stateCode ? `, ${store.stateCode}` : ''}${store.postalCode ? `, ${store.postalCode}` : ''}${store.countryCode ? `, ${store.countryCode}` : ''}</p>
              </div>
            <div class="hc-store-dropdown-details-column">
            <p class="hc-text">
              ${store.storePhone ? '<i class="fa fa-phone hc-icon hc-list-icon" tabindex="0"></i>' : ''}
              <a href="tel:${store.storePhone ? store.storePhone : ''}">${store.storePhone ? store.storePhone : ''}</a>
            </p>
            <p class="hc-text">
            ${storeTodayTiming.open ? '<i class="fa fa-regular fa-clock hc-icon hc-list-icon" tabindex="0"></i>' : ''}
              ${storeTodayTiming.open ? 'Open Today: <wbr>' + storeTodayTiming.open + ' - ': ''} ${ storeTodayTiming.close ? storeTodayTiming.close : ''}
              </p>
              </div>
        </div>`);
  
        return $storeInformationCard;
    }
  
    /*
      Updates the home store for the user whenever user changes the home store either from the header dropdown or from PDP page
  
      @param {object} store The store object which will be the home store
      @param {event} event custom event pbject
      */
    async function updateUserStorePreference(store, event) {
  
        // empty the store information element as to clear the record and update it
        // This check is needed to enable mutation observer when store changes from find-a-store page, as when changing store from find-a-store page no DOM mainpulation happens
        jQueryBopis('.hc-store-information').empty();
  
        latlon = '' // making latlon empty whenever changing the home store, if not then when fetching the stores again, it honors the searched zipcode latlon
  
        // updating currentStore information(storeCode, name, and latlon) in the localStorage
        store.storeName && (localStorage.setItem('HC_CURRENT_STORE_NAME', store.storeName)); // storing home store name in localStorage, as to display store name on collection/category page
        store.latlon && (localStorage.setItem('HC_CURRENT_STORE_LAT_LON', store.latlon)); // storing home store latLon in localStorage to use when fetching stores information on the basis of homeStore latLon
        localStorage.setItem('HC_CURRENT_STORE', store.storeCode);
  
        // if the user is logged-in then updating the customer's defaultStore information
        // if (customerId && shopifyShopId) {
        //     await setCustomerDefaultStore(store.storeCode);
        // }
  
        // closes the dropdown selector, after setting the home store, if the home store is set from dropdown
        const eventTargetClass = jQueryBopis(event.target)[0].className;
        if (eventTargetClass.includes("hc-home-store-dropdown-button")) {
            closeStoreDropdown();
        }
  
        // always closing PDP bopis selector
        // closeBopisSelectorInline();
    }

    function updateHomeStoreDistance(dist) {
      const homeStoreDist = jQueryBopis("#hc-my-store > #hc-store-dropdown-card > .hc-store-title > span")

      const distance = dist && dist != 'Infinity' ? parseFloat((dist).toFixed(1)).toLocaleString() + ' mi' : ''
      homeStoreDist.text(distance);
    }
  
    /*
      Renders passed stores on the UI as child elements of parentId
  
      @param {array} stores Array of stores to be displayed on UI
      @param {string} parentIdentifier
      */
      function renderStoresInDropdown(stores, parentIdentifier) {
        removeLoader(parentIdentifier);
  
        const $parent = jQueryBopis(parentIdentifier);

        if(!Array.isArray(stores) || stores.length <= 0) {
            $parent.append('<div style="justify-self: flex-start">No stores found</div>');
            return;
        }

        const storeDropdownCards = stores.map((store) => {
            let $storeDropdownCard = jQueryBopis('<div class="hc-store-dropdown-card"></div>');
            $storeDropdownCard.append(generateStoreInformationDropdownCard(store));

            // only display `SET AS MY STORE` when the current store is not the homeStore and pickup is allowed on the store
            if (store.pickup_pref && !store.isHomeStore) {
                renderedStoresByCode[store.storeCode] = store;
                let $setAsHomeStoreButton = jQueryBopis(`<div class="hc-home-store-dropdown-button hc-pointer" tabindex="0" style="color: #C59A2A" data-store-code="${store.storeCode}">SET AS MY STORE</div>`);
                $storeDropdownCard.append($setAsHomeStoreButton);
            }

            if (!store.pickup_pref) {
              $storeDropdownCard.append(jQueryBopis('<h4 style="margin-top: 10px; text-align: start; font-size: .8em;" tabindex="0">Store Pickup Unavailable</h4>'));
            }

            let $lineBreak = jQueryBopis('<hr class="hc-horizontal-rule"/>')
            $storeDropdownCard.append($lineBreak);

            return $storeDropdownCard;
        })

        // appending all the store cards in a single DOM operation instead of once per store
        $parent.append(storeDropdownCards);

        // hide all the h4 and p tags which are empty in the modal
        $parent.find('h4:empty').hide();
        $parent.find('p:empty').hide();
    }
  
    /*
      Function handles the logic for store search in the dropdown
      */
      async function searchStoresInDropdown(event) {
        jQueryBopis('#hc-other-stores').empty();
        addLoader('#hc-other-stores');
  
        event.preventDefault();
        const zipCode = jQueryBopis(".hc-bopis-store-pin").val()
        const userHomeStoreCode = getUserStorePreference();
  
        // if we have user's location point then changing the title to Results as the stores are fetched on the basis of user's location
        if(userLocationPoint) {
            jQueryBopis('#hc-other-stores-title > .hc-store-dropdown-title').text('Results:');
        } else if(!zipCode) {
            // if made an empty search then not fetching the latlon from server and assigning latlon an empty value
            jQueryBopis('#hc-other-stores-title > .hc-store-dropdown-title').text(`${userHomeStoreCode ? 'Other Stores:' : 'Select a Store'}`);
            latlon = '';
        } else {
            jQueryBopis('#hc-other-stores-title > .hc-store-dropdown-title').text('Results:');
            !latlon && (latlon = await getLatLonForZipCode(zipCode));
        }
  
        // removing the fa-location-pin-lock icon and adding fa-location-dot icon if user's location is not available but the current icon is pin-lock
        if(!userLocationPoint && jQueryBopis('.hc-bopis-form i').hasClass('fa-location-pin-lock')) {
            jQueryBopis('.hc-bopis-form i').removeClass('fa-location-pin-lock').addClass('fa-location-dot')
        }
  
        // making userLocationPoint empty after checking some UI condition as once the searchbar is used for searching
        // we don't need to have lock icon for location in search bar
        userLocationPoint = ''
  
        // If the latlon for searched zipcode is not present then display error string
        if(zipCode && !latlon) {
            updateHomeStoreDistance("")
            renderStoresInDropdown([], '#hc-other-stores')
            return;
        }
  
        let searchedStores = stores;
  
        if(latlon) {
            searchedStores = await fetchStores();
        }
  
        if (searchedStores && searchedStores.length > 0) {
            searchedStores.map((store) => {
                if(store.storeCode === userHomeStoreCode) {
                    store.isHomeStore = true
                } else {
                    store.isHomeStore = false
                }
            })
  
            const otherStores = searchedStores.filter((store) => store.storeCode !== userHomeStoreCode);
            const homeStore = searchedStores.find((store) => store.storeCode === userHomeStoreCode);
  
            if(homeStore) {
              updateHomeStoreDistance(homeStore.dist)
            }
            // only display home store information again in other stores, when some searched is made otherwise do not display
            // home store information
            if (!zipCode) {
                renderStoresInDropdown(otherStores, '#hc-other-stores')
                latlon = ''
                return;
            }
  
            renderStoresInDropdown(searchedStores, '#hc-other-stores')
        } else {
            updateHomeStoreDistance("")
            // if no stores found for the searched zipCode
            renderStoresInDropdown([], '#hc-other-stores')
        }
        latlon = ''
    }
  
    /*
      Function added the store search form in the dropdown and defines click event for location icon and button
      */
      function renderStoreSearchFormInDropdown() {
        const bopisForm = jQueryBopis(`<form class="hc-bopis-form">
            <div class="hc-input-wrapper">
                <input class="hc-bopis-store-pin" name="pin" aria-label="${bopisCustomConfig.searchInputPlaceholder}" placeholder="${bopisCustomConfig.searchInputPlaceholder}" style="width: 100%; border:0px;"/>
                <i class="fa-solid fa-xmark hc-icon hc-close-icon" style="display: none;" tabindex="0"></i>
                <i class="fa-solid fa-location-dot hc-icon hc-location-icon" tabindex="0"></i>
            </div>
            <button type="submit" class="button hc-bopis-pick-up-button">Find Stores</button>
        </form>`)
        jQueryBopis('#hc-dropdown-bopis-form').append(bopisForm);
  
        // calling toggleClearIcon function when the input event is triggered
        jQueryBopis('.hc-bopis-store-pin').on('input', toggleClearIcon.bind(null, '.hc-bopis-form'));
        jQueryBopis(".hc-bopis-form .hc-close-icon").on('click', clearSearch.bind(null, '.hc-bopis-form'))
  
        jQueryBopis(".hc-bopis-form .hc-location-icon").on('click', fetchStoresUsingCurrentLocation.bind(null, '.hc-bopis-form'));
  
        jQueryBopis(".hc-bopis-pick-up-button").on('click', searchStoresInDropdown);
    }
  
    /*
      Function checks for homeStore and otherStores and then calls renderStoresInDropdown to display store information on UI
      */
      function updateStoresInformationInDropDown() {
        if (jQueryBopis('.hc-caret-icon').length == 0) {
            const caretDownIcon = jQueryBopis('<i class="fa fa-caret-down hc-caret-icon" style="cursor: pointer;"></i>')
            homeStore.append(caretDownIcon);
        }
  
        jQueryBopis("#hc-store-dropdown").remove();
  
        let $storeDropdown = jQueryBopis(`<div id="hc-store-dropdown" class="hc-store-dropdown">
            <div class="hc-store-dropdown-content">
                <div class="hc-store-dropdown-information">
                    <div id="hc-home-store-information-dropdown">
                        <div id="hc-my-store-title"></div>
                        <div id="hc-my-store"></div>
                    </div>
                    <div id="hc-dropdown-bopis-form"></div>
                    <div id="hc-other-stores-information-dropdown">
                        <div id="hc-other-stores-title"></div>
                        <div id="hc-other-stores"></div>
                    </div>
                </div>
            </div>
        </div>`);
  
        jQueryBopis("#hc-my-store-bopis").append($storeDropdown);
  
        if (userHomeStore) {
            const storeTodayTiming = getStoreTodayTiming(userHomeStore.timings);
            const homeStoreName = userHomeStore.storeName + ' ' + (storeTodayTiming.open && storeTodayTiming.close ? `<span id="home-store-metadata">(Open from ${storeTodayTiming.open} to ${storeTodayTiming.close})</span>` : '<span id="home-store-metadata">(Closed Today)</span>')
            jQueryBopis('#hc-home-store #store').html(homeStoreName);
  
            let $userHomeStoreTitle = jQueryBopis('<h2 class="hc-store-dropdown-title hc-font-xl">My Store:</h2>');
            jQueryBopis('#hc-my-store-title').append($userHomeStoreTitle);
  
            renderStoresInDropdown([userHomeStore], '#hc-my-store')
        }
  
        renderStoreSearchFormInDropdown();
  
        if (otherStores && otherStores.length) {
            let $otherStoresTitle = jQueryBopis(`<h2 class="hc-store-dropdown-title hc-font-xl">${userHomeStore ? 'Other Stores:' : 'Select a Store'}</h2>`);
            jQueryBopis('#hc-other-stores-title').append($otherStoresTitle);
        }
  
        // removing all the children from hc-other-stores, as when searching we need to clear all the previous data
        jQueryBopis('#hc-other-stores').empty();
  
        renderStoresInDropdown(otherStores, '#hc-other-stores');
  
        homeStore.on('click', function (event) {
            if(jQueryBopis(".hc-store-dropdown").css('display') === "none") {
                openStoreDropdown(event);
            } else {
                closeStoreDropdown(event);
            }
        })
    }
  
    /*
      Function calls the getStoreInformation method to get the store information and prepare the store timing object for the stores
  
      @return {array} An array of object containing stores information, and empty if stores not found
      */
    async function fetchStores() {
        let storesInformationResp;
  
        try {
            storesInformationResp = await getStoreInformation();
        } catch(err) {
            // if storeLookup api throws any error than removing the loader added and also changed text to default text
            jQueryBopis('#hc-home-store #store > .hc-loading').remove();
            jQueryBopis('#hc-home-store #store').text('Select a store');
        }
        let storesInformation = [];
  
        if(storesInformationResp && storesInformationResp.response && storesInformationResp.response.numFound > 0) {
            storesInformation = storesInformationResp.response.docs.map((store) => {
                store.timings = getStoreTiming(store);
                return store;
            })
        }
        return storesInformation;
    }
  
  
    /*
      It fetches the updated stores information by calling fetchStores function and then set the userHomeStore and otherStores information globally
      Also, calls the functions to update stores information in dropdown and on PDP
    */
    async function updateStoresInformation() {
        const userHomeStoreCode = getUserStorePreference();
  
        // only adding loaders only when we have some information of homeStore to update
        if(userHomeStoreCode) {
            // empty the home store information in the header and adds a loader on the same
            jQueryBopis('#hc-home-store #store').empty();
            addHomeStoreLoader();
  
            // empty the pdp store information and add a loader on the same
            // jQueryBopis('.hc-bopis-pdp-information').hide();
            // addLoader('.hc-bopis-store-information')
        }
  
        // empty the store information element and add a loader on the same
        // jQueryBopis('.hc-store-information').empty();
        // addLoader('.hc-store-information');
  
        stores = await fetchStores();
  
        // assigning initial values to global variables
        userHomeStore = ''
        otherStores = []
  
        if(stores.length > 0) {
            userHomeStore = userHomeStoreCode ? stores.find((store) => store.storeCode === userHomeStoreCode) : '';
            otherStores = userHomeStoreCode ? stores.filter((store) => store.storeCode !== userHomeStoreCode) : stores;
  
            if(userHomeStore) {
                userHomeStore.isHomeStore = true;
            }
  
            otherStores.map((store) => store.isHomeStore = false)
        }
  
        updateStoresInformationInDropDown();
  
          // only update stores information on PDP when we are on product details page
        if(location.pathname.includes('/products/')) {
            await initialiseBopis();
        }

        // only update stores information when on find a store page
        // if(location.pathname.includes('find-a-store')) updateStoresInformationOnStorePage();
    }
  
    // function will open the modal for the stores information
    function openStoreDropdown (event) {
          // to stop event bubbling when clicking on the Check Stores button
          event.preventDefault();
          event.stopImmediatePropagation();
  
          let dropdownBackdrop = jQueryBopis('<div id="hc-dropdown-backdrop"></div>');
          body.append(dropdownBackdrop);
  
          jQueryBopis('#hc-home-store .hc-caret-icon').remove();
          const caretUpIcon = jQueryBopis('<i class="fa fa-caret-up hc-caret-icon" style="cursor: pointer;"></i>')
          homeStore.append(caretUpIcon);

          // add overflow style to disable background scroll when modal is opened
          body.css("overflow", "hidden");
          jQueryBopis(".hc-store-dropdown").show();
    }
  
    function closeStoreDropdown () {
        jQueryBopis('#hc-home-store .hc-caret-icon').remove();
        const caretDownIcon = jQueryBopis('<i class="fa fa-caret-down hc-caret-icon" style="cursor: pointer;"></i>')
        homeStore.append(caretDownIcon);
        jQueryBopis(".hc-store-dropdown").hide();
        body.css("overflow", "scroll");
        jQueryBopis("#hc-dropdown-backdrop").remove();
    }

    function getVariantSku() {
        const variantId = jQueryBopis(".hc-product-form .selected-variant-id").val()

        if(variantId) {
          const variant = hc_product_information[variantId]
          return variant ? variant.sku : "";
        }

        return "";
    }
  
    async function initialiseBopis () {  
        if (location.pathname.includes('/products/')) {
            // jQueryBopis(".hc-store-information").remove();
            jQueryBopis(".hc-bopis-modal").remove();
            const bopisButton = jQueryBopis("#hc-bopis-button");
            const existingBopisButton = jQueryBopis("#hc-bopis-button > button");

            // Do not enable BOPIS when the current product is not available
            if(!isProductAvailable()) {
                existingBopisButton.remove();
                return;
            }

            let $pickUpModal = jQueryBopis(`<div id="hc-bopis-modal" class="hc-bopis-modal">
                <div class="hc-modal-content">
                <span class="hc-close hc-bopis-close fa-2xl"></span>
                    <div class="hc-modal-header">
                        <h1 class="hc-modal-title">Pick up today</h1>
                    </div>
                    <form id="hc-bopis-form-pdp">
                      <div class="hc-input-wrapper">
                          <input id="hc-bopis-store-pin" name="pin" placeholder="Enter zipcode" style="width: 100%; border:0px;"/>
                          <i class="fa-solid fa-xmark hc-icon hc-close-icon" style="display: none;" tabindex="0"></i>
                          <i class="fa-solid fa-location-dot hc-icon hc-location-icon" tabindex="0"></i>
                      </div>
                      <button type="submit" class="button hc-bopis-pick-up-button">Find Stores</button>
                    </form>
                    <div class="hc-store-information"></div>
                    <p class="hc-store-not-found"></p>
                </div>
            </div>`);
  
            // check if the element with id hc-bopis-button has button element in it then don't add button
            if (existingBopisButton.length == 0) {
                let $btn = jQueryBopis('<button class="button button--secondary hc-open-bopis-modal">Pick Up In Store</button>');
                bopisButton.append($btn);
            }
  
            jQueryBopis("body").append($pickUpModal);
  
            // namespaced off/on so re-initialising on variant/store change does not stack handlers
            bopisButton.off('click.bopis').on('click.bopis', openBopisModal);
  
            jQueryBopis(".hc-bopis-close").on('click', closeBopisModal);
            jQueryBopis("body").on('click', function(event) {
                if (event.target == jQueryBopis("#hc-bopis-modal")[0]) {
                    closeBopisModal();
                  }
              })
              
              jQueryBopis('#hc-bopis-store-pin').on('input', toggleClearIcon.bind(null, '#hc-bopis-form-pdp'));
              jQueryBopis("#hc-bopis-form-pdp .hc-close-icon").on('click', clearSearch.bind(null, '#hc-bopis-form-pdp'))
              jQueryBopis("#hc-bopis-form-pdp .hc-location-icon").on('click', handleAddToCartEvent.bind(null, true));
              jQueryBopis(".hc-bopis-pick-up-button").on('click', handleAddToCartEvent.bind(null, false));
  
        } else if(location.pathname.includes("/cart/")) {
            // finding this property on cart page as some themes may display hidden properties on cart page
            jQueryBopis("[data-cart-item-property-name]:contains('pickupstore')").closest('li').hide();
        }
    }
  
    function getStoreInformation(queryString) {
        const payload = {
            viewSize: 100,
            filters: ["storeType: RETAIL_STORE"]
        }
  
        // fetching home store latLon from localStorage
        const homeStoreLatLon = localStorage.getItem('HC_CURRENT_STORE_LAT_LON');
  
        if(latlon) {
            payload["point"] = latlon
        } else if (homeStoreLatLon) {
          payload["point"] = homeStoreLatLon
        }
  
        // applied a condition that if we have location permission then searching the stores for the current location
        // if we have both location and pin, then using the pin to search for stores
        // if we doesn't have location permission and pin, then will fetch all the available stores
        return new Promise(function(resolve, reject) {
            jQueryBopis.ajax({
                type: 'POST',
                url: `${baseUrl}/api/storeLookup`,
                crossDomain: true,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),
                success: function (res) {
                    resolve(res)
                },
                error: function (err, textStatus) {
                    reject(textStatus);
                }
            })
        })
    }
  
    async function checkInventory(payload) {
        const storeIdParam = payload.facilityIds.map((id) => `&facilityIds=${id}`);
  
        let resp;
  
        // added try catch to handle network related errors
        try {
            resp = await new Promise(function(resolve, reject) {
                jQueryBopis.ajax({
                    type: 'GET',
                    url: `${maargUrl}/rest/s1/ofbiz-oms-usl/checkBopisInventory?productStoreId=STORE&inventoryGroupId=FAC_GRP&internalNames=${payload.sku}${storeIdParam.join('')}`,
                    crossDomain: true,
                    dataType: 'JSON',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    success: function (data) {
                        resolve(data);
                    },
                    error: function (xhr, textStatus, exception) {
                        reject(textStatus)
                    }
                })
            })
        } catch (err) {
            resp = err;
        }
        return resp;
    }
    
    async function handleAddToCartEvent(useCurrentLocation = false, event) {
        let eventTarget;
        if (event) {
            eventTarget = jQueryBopis(event.target);
            // to stop event bubbling when clicking on the Check Stores button
            event.preventDefault();
            event.stopImmediatePropagation();
        }
  
        const queryString = jQueryBopis("#hc-bopis-store-pin").val();
  
        if(useCurrentLocation) {
          jQueryBopis("#hc-bopis-store-pin").val("")
          try {
              const userLocation = await getCurrentLocation()
              $location = userLocation.coords;
          } catch(err) {
              console.error(err.message)
          }
          userLocationPoint = $location ? `${$location.latitude}, ${$location.longitude}` : ''
          let zipCode = ''
    
          // user's latLon are available then only fetching the zipCode for the latLon
          if(userLocationPoint) {
              zipCode = await getZipCodeForLatlon(userLocationPoint);
          }
          latlon = userLocationPoint;
          jQueryBopis("#hc-bopis-form-pdp i").removeClass('fa-location-dot').addClass('fa-location-pin-lock');
          jQueryBopis("#hc-bopis-form-pdp input").val(zipCode);
          // checking for zipCode as in some cases we might not have zipCode available for a latLon and in that we don't need to display the clear icon
          // triggering input event, as when using val() function to update the value of input, input event does not trigger automatically
          // TODO: check if we require an else case here
          if(zipCode) {
              jQueryBopis("#hc-bopis-form-pdp input").trigger('input');
          }
        } else {
          latlon = queryString ? await getLatLonForZipCode(queryString) : '';
        }
  
        // removing the fa-location-pin-lock icon and adding fa-location-dot icon if user's location is not available but the current icon is pin-lock
        if(!userLocationPoint && jQueryBopis('#hc-bopis-form-pdp i').hasClass('fa-location-pin-lock')) {
          jQueryBopis('#hc-bopis-form-pdp i').removeClass('fa-location-pin-lock').addClass('fa-location-dot')
      }
  
  
        let storeInformation = await getStoreInformation(queryString).then(data => data).catch(err => err);
        let result = '';
  
        const sku = getVariantSku()
  
        jQueryBopis('#hc-store-card').remove();
        if (event) eventTarget.prop("disabled", true);
  
        // checking if the number of stores is greater then 0 then creating a payload to check inventory
        if (storeInformation && storeInformation.response && storeInformation.response.numFound > 0) {
  
            let storeCodes = storeInformation.response.docs.filter(store => store["pickup_pref"] === "true").map((store) => {
                let storeCode = '';
                store.timings = getStoreTiming(store);
  
                // if storeCode starts with DC_ then removing the code
                if (store.storeCode.startsWith('DC_')) {
                    storeCode = store.storeCode.substring(3);
                } else {
                    storeCode = store.storeCode;
                }
  
                store.storeCode = storeCode;
                return storeCode;
            })
  
            // passing the facilityId as an array in the payload
            let payload = {"sku" : sku, "facilityIds": storeCodes};
            result = await checkInventory(payload)
  
            // mapping the inventory result with the locations to filter those stores whose inventory
            // is present and the store code is present in the locations.
            if (result.resultList) {
                result = storeInformation.response.docs.filter(store => store["pickup_pref"] === "true").filter((location) => {
                    return result.resultList.some((doc) => {
                          if(doc.facilityId === location.storeCode && doc.atp > 0) {
                              location["isInStock"] = true;
                          } else {
                              location["isInStock"] = false;
                          }
                        return location.isInStock;
                    })
                })
            }
        }
  
        if(queryString && !latlon) {
            displayStoreInformation([])
        } else {
            displayStoreInformation(result)
        }
        displayHomeStoreInformation(storeInformation.response.docs.filter(store => store["pickup_pref"] === "true"))
        if (event) eventTarget.prop("disabled", false);
    }
  
    /*
        Function finds the name for day of the week
  
        @return {string} Day of the week
    */
    function getDay() {
        let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        let date = new Date();
        let dayName = days[date.getDay()];
        return dayName;
    }
  
    function getStoreTodayTiming(timing) {
        return timing[getDay()] ? timing[getDay()] : {};
    }
  
    function getConvertedTime (time) {
        if (time) {
            // Check correct time format and split into components
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  
            if (time.length > 1) { // If time format correct
                time.pop(); // remove seconds from the time
                time = time.slice(1); // Remove full string match value
                time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join(''); // return adjusted time or original string
        }
        return '';
    }
  
    /*
    Function returns the open and close timing for a store for all week days
  
    @param {object} store An object containing store information
    @return {object} An object containing open and close timing for all week days
    */
    function getStoreTiming(store) {
        let days = {'monday': {}, 'tuesday': {}, 'wednesday': {}, 'thursday': {}, 'friday': {}, 'saturday': {}, 'sunday': {}};
  
        const storeTimingDays = Object.keys(store).filter((key) => key.includes('open') || key.includes('close'));
  
        return storeTimingDays.reduce((obj, key) => {
            const time = store[key];
            if (key.includes('open')) {
                obj[key.replace('_open', '')]['open'] = getConvertedTime(time)
            }
            if (key.includes('close')) {
                obj[key.replace('_close', '')]['close'] = getConvertedTime(time)
            }
            return obj;
        }, days)
    }
  
    /*
        Fetch the latlon information for a zip, if present.
  
        @param {number} zipCode for which the latlon needs to be fetched
        @return {number} location for the zipcode in the format <lat,lon>
    */
    async function getLatLonForZipCode(zipCode) {
        let latLon = ''
  
        // Need to check for leading zero, as we have indexing specific issue when the zip starts with 0
        const query = zipCode.startsWith('0') ? `${zipCode} OR ${zipCode.substring(1)}` : zipCode;
  
        const payload = {
            "json": {
                "params": {
                    "q": `postcode:${query}`
                }
            }
        }
  
        try {
            latLon = await new Promise(function(resolve, reject) {
                jQueryBopis.ajax({
                    type: 'POST',
                    url: `${baseUrl}/api/postcodeLookup`,
                    data: JSON.stringify(payload),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    crossDomain: true,
                    success: function (data) {
                        // added error check in here as in error case, api still returns 200 but has an error in response
                        if(data.error) {
                            reject('')
                        } else {
                            // assuming that when fetching the latlon for a zipcode there will only be one associated
                            // latlon for a zipcode and hence accessing the 0th index of docs
                            resolve(data.response.numFound > 0 ? data.response.docs[0].location : '');
                        }
                    },
                    error: function (xhr, textStatus, exception) {
                        reject(textStatus)
                    }
                })
            })
        } catch (err) {
            latLon = ''
        }
        return latLon;
    }
  
    /*
        Fetch the zipCode information for the latlon, and does not honor proximity.
  
        @param {string} pt lat,lon for which the zipCode needs to be fetched
        @return {string} code for the passed latlon if found, otherwise empty
    */
    async function getZipCodeForLatlon(pt) {
        let zipCode = ''
        const payload = {
            "json" : {
                "params": {
                    "q": "*:*",
                    "fq": "{!geofilt sfield=location}",
                    "pt": pt,
                    "d": 50 // passed d as 50, as we want zipCode in 50 radius
                }
            }
        }
  
        try {
            zipCode = await new Promise(function(resolve, reject) {
                jQueryBopis.ajax({
                    type: 'POST',
                    url: `${baseUrl}/api/postcodeLookup`,
                    data: JSON.stringify(payload),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    crossDomain: true,
                    success: function (data) {
                        if(data.error) {
                            reject('')
                        } else {
                            // assuming that when fetching the zipcode for a latlon there will be multiple
                            // zipcodes as we are passing d as 50 and hence accessing the 0th index of docs
                            resolve(data.response.numFound > 0 ? data.response.docs[0].postcode : '');
                        }
                    },
                    error: function (xhr, textStatus, exception) {
                        reject(textStatus)
                    }
                })
            })
        } catch (err) {
            zipCode = ''
        }
        return zipCode;
    }
  
      // will check for the inventory for the product stock and if available then display the information on the UI
      function displayHomeStoreInformation(storeInformation) {
  
          const homeStoreWrapper = jQueryBopis('#hc-home-store-pdp')
  
          homeStoreWrapper.empty();
          const userHomeStoreCode = getUserStorePreference();
  
          if (userHomeStoreCode) {
  
              let homeStore = storeInformation.find(store => store.storeCode === userHomeStoreCode)
  
              if(!homeStore) {
                  homeStore = stores.find(store => store.storeCode === userHomeStoreCode)
              }
  
              if(!homeStore) {
                  return;
              }
  
              homeStoreWrapper.append('<h6 style="margin: unset;">My Store:</h6>')
              let $storeCard = jQueryBopis('<div class="hc-store-card"></div>');
              const storeTodayTiming = getStoreTodayTiming(homeStore.timings);

              let $storeInformationCard = jQueryBopis(`
                  <div class="hc-store-details">
                      <div class="hc-details-column">
                          <p class="hc-store-dist-metadata">${homeStore.dist && homeStore.dist !== "Infinity" ? parseFloat((homeStore.dist).toFixed(1)).toLocaleString() + ' mi. away from you' : ''}</p>
                          <h4 class="hc-store-title hc-font-m">${homeStore.storeName ? homeStore.storeName : ''}</h4>
                          <p>${homeStore.address1 ? homeStore.address1 : ''}</p>
                          <p>${homeStore.city ? homeStore.city : ''}${homeStore.stateCode ? `, ${homeStore.stateCode}` : ''}${homeStore.postalCode ? `, ${homeStore.postalCode}` : ''}${homeStore.countryCode ? `, ${homeStore.countryCode}` : ''}</p>
                      </div>
                      <div class="hc-details-column">
                          <p>
                          <i class="fa ${homeStore.isInStock ? 'fa-check' : 'fa-xmark'} hc-icon hc-list-icon" tabindex="0" style="color: ${homeStore.isInStock ? 'green' : 'red'};"></i>
                          ${homeStore.isInStock ? 'In stock' : 'Out of stock'}
                          </p>
                          <p>
                          <i class="fa fa-phone hc-icon hc-list-icon" tabindex="0"></i>
                          <a href="tel:${homeStore.storePhone}">${homeStore.storePhone ? homeStore.storePhone : '-'}</a>
                          </p>
                          <p>
                          <i class="fa fa-regular fa-clock hc-icon hc-list-icon" tabindex="0"></i>
                          ${ storeTodayTiming.open ? 'Open Today: <wbr>' + storeTodayTiming.open + ' - ': ''} ${storeTodayTiming.close ? storeTodayTiming.close : ''}
                          </p>
                      </div>
                  </div>`);
                  $storeCard.append($storeInformationCard);
  
                  if(homeStore.isInStock) {
                      renderedStoresByCode[homeStore.storeCode] = homeStore;
                      let $pickUpButton = jQueryBopis(`<button class="button button--secondary hc-store-pick-up-button" data-store-code="${homeStore.storeCode}">Pick Up Here</button>`);

                      $storeCard.append($pickUpButton);
                  }
  
                  let $lineBreak = jQueryBopis('<hr/>')
                  $storeCard.append($lineBreak);
  
              homeStoreWrapper.append($storeCard);
          }
      }
  
  
    // will check for the inventory for the product stock and if available then display the information on the UI
    function displayStoreInformation(result) {

        const $storeInformation = jQueryBopis('.hc-store-information');
        $storeInformation.empty();
        // TODO Handle it in a better way
        // The content of error is not removed and appended to last error message
        jQueryBopis('.hc-store-not-found').remove();
        jQueryBopis('.hc-modal-content').append(jQueryBopis('<p class="hc-store-not-found"></p>'));
        const hcModalContent = jQueryBopis('.hc-modal-content')

        $storeInformation.append('<div id="hc-home-store-pdp"></div>')

        const userHomeStoreCode = getUserStorePreference();

        //check for result count, result count contains the number of stores count in result
        //TODO: find a better approach to handle the error secenario
        if (result.length > 0 && !result.includes('error')) {
            const storeCards = result.filter((store) => store.storeCode !== userHomeStoreCode).map((store) => {
                let $storeCard = jQueryBopis('<div class="hc-store-card"></div>');
                const storeTodayTiming = getStoreTodayTiming(store.timings);
                let $storeInformationCard = jQueryBopis(`
                <div class="hc-store-details">
                    <div class="hc-details-column">
                      <p class="hc-store-dist-metadata">${store.dist && store.dist !== "Infinity" ? parseFloat((store.dist).toFixed(1)).toLocaleString() + ' mi. away from you' : ''}</p>
                      <h4 class="hc-store-title hc-font-m">${store.storeName ? store.storeName : ''}</h4>
                      <p>${store.address1 ? store.address1 : ''}</p>
                      <p>${store.city ? store.city : ''}${store.stateCode ? `, ${store.stateCode}` : ''}${store.postalCode ? `, ${store.postalCode}` : ''}${store.countryCode ? `, ${store.countryCode}` : ''}</p>
                    </div>
                    <div class="hc-details-column">
                      <p>
                        <i class="fa fa-check hc-icon hc-list-icon" tabindex="0" style="color: green;"></i>
                        In stock
                      </p>
                      <p>
                        <i class="fa fa-phone hc-icon hc-list-icon" tabindex="0"></i>
                        <a href="tel:${store.storePhone}">${store.storePhone ? store.storePhone : '-'}</a>
                      </p>
                      <p>
                        <i class="fa fa-regular fa-clock hc-icon hc-list-icon" tabindex="0"></i>
                        ${ storeTodayTiming.open ? 'Open Today: <wbr>' + storeTodayTiming.open + ' - ': ''} ${storeTodayTiming.close ? storeTodayTiming.close : ''}
                      </p>
                    </div>
                </div>`);

                renderedStoresByCode[store.storeCode] = store;
                let $pickUpButton = jQueryBopis(`<button class="button button--secondary hc-store-pick-up-button" data-store-code="${store.storeCode}">Pick Up Here</button>`);

                let $lineBreak = jQueryBopis('<hr/>')

                $storeCard.append($storeInformationCard);
                $storeCard.append($pickUpButton);
                $storeCard.append($lineBreak);

                return $storeCard;
            })

            // appending all the store cards in a single DOM operation instead of once per store
            $storeInformation.append(storeCards);

            //check whether any store cards were added, if not then displaying error
            if (storeCards.length === 0) {
                jQueryBopis('.hc-store-not-found').html('No stores found for this product');
            }
        } else {
          // Added check for length 2, as we are displaying the home store inside the hc-store-information element
          // and in that case we do not need to display the below error and home store card will always be in hc-store-information
          // wrapper even when home store is not selected
            if ($storeInformation.children().length < 2) {
                jQueryBopis('.hc-store-not-found').append('No stores found for this product');
            }
        }

        // hide all the h4 and p tags which are empty in the modal
        hcModalContent.find('h4:empty').hide();
        hcModalContent.find('p:empty').hide();
    }
    
    // will add product to cart with a custom property pickupstore
    function updateCart(store, event) {
        let addToCartForm = jQueryBopis(".hc-product-form");
  
        event.preventDefault();
        event.stopImmediatePropagation();
                
        // let merchant define the behavior whenever pick up button is clicked, merchant can define an event listener for this event
        jQueryBopis(document).trigger('prePickUp');
  
        // made the property hidden by adding underscore before the property name
        let facilityIdInput = jQueryBopis(`<input name="properties[_pickupstore]" value=${store.storeCode ? store.storeCode : ''} type="hidden"/>`)
        addToCartForm.append(facilityIdInput)

      //   Added this property to be used in the fulfillment flow
        let shopifyLocationIdInput = jQueryBopis(`<input name="properties[_shopifyLocationId]" value=${store.storeCode ? locationJSON[store.storeCode] : ''} type="hidden"/>`)
        addToCartForm.append(shopifyLocationIdInput)

      //   Added this property to be used in the checkout shipping rate extension
        let deliveryMethodInput = jQueryBopis(`<input name="properties[_deliveryMethod]" value="Pick Up At ${store.storeName ? store.storeName : ''}${store.address1 ? `, ${store.address1}` : ''}" type="hidden"/>`)
        addToCartForm.append(deliveryMethodInput)
  
        let facilityNameInput = jQueryBopis(`<input id="hc-pickupstore-address" name="properties[Pickup Store]" value="${store.storeName ? store.storeName : ''}${store.address1 ? `, ${store.address1}` : ''}${store.city ? `, ${store.city}` : ''}" type="hidden"/>`)
        addToCartForm.append(facilityNameInput)
  
        // using the cart add endpoint to add the product to cart, as using the theme specific methods is not recommended.
        jQueryBopis.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: addToCartForm.serialize(),
            dataType: 'JSON',
            success: function () {
                // Closing modal and let the postPickUp event handle the redirection flow
                closeBopisModal();
                // let merchant define the behavior after the item is successfully added as a pick up item, merchant can define an event listener for this event
                jQueryBopis(document).trigger('postPickUp');
            }
        })
  
        facilityIdInput.remove();
        facilityNameInput.remove();
    }
  
    // TODO move it to intialise block
    // To check whether the url has changed or not, for making sure that the variant is changed.
    let url = location.href;
    let currentHomeStore = getUserStorePreference();
    new MutationObserver(async () => {
          if (location.href !== url) {
              url = location.href;
              await initialiseBopis();
          }
  
          // Fetch the stores again whenever current store changes
          // Need to fetch stores again as the distance between stores is calculated on the basis of current store
          if (currentHomeStore !== getUserStorePreference()) {
              currentHomeStore = getUserStorePreference();
              updateStoresInformation();
          }
        // added condition to run the script again as when removing a product the script does not run
        // and thus the store id again becomes visible
      //   if (location.pathname.includes('cart')) initialiseBopis();
    }).observe(document, {subtree: true, childList: true});  
})();
